module.exports = __webpack_public_path__ + "static/img/5-4.4aaf1f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-5/5-4.jpg
// module id = 746
// module chunks = 1